import React from 'react';

import type { Nullable } from '@clearverify/types';

import { useGetVerifierInfoByApiVerificationRequestQuery } from 'src/api';

type UseVerifierByApiVerificationRequestIdParams = {
  inboxItemId?: Nullable<string>;
  skip?: boolean;
};

export const useVerifierByApiVerificationRequestId = ({
  inboxItemId,
  skip,
}: UseVerifierByApiVerificationRequestIdParams) => {
  const { data, loading } = useGetVerifierInfoByApiVerificationRequestQuery({
    variables: { inboxItemId: inboxItemId || '' },
    skip: skip || !inboxItemId,
  });

  const verifier = React.useMemo(
    () => data?.getVerifierInfoByApiVerificationRequest,
    [data?.getVerifierInfoByApiVerificationRequest],
  );

  return { verifier, loading };
};
